// extracted by mini-css-extract-plugin
module.exports = {"delete":"src-components-page-lh-registration-DeleteButton-module__delete--23nXN","noLabel":"src-components-page-lh-registration-DeleteButton-module__noLabel--rN7Vg"};